import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { EmptyState } from "@/components/common/EmptyState";
import { SurfaceCard } from "@/components/common/Cards";
import { StatusBadge } from "@/components/common/StatusBadge";
import { formatDate } from "@/lib/format";
import { FileBarChart, Sparkles, ChevronRight } from "lucide-react";

export default function AIReports() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/reports").then((r) => setItems(r.data.filter((x) => x.ai_generated))).catch(() => setItems([])); }, []);
  return (
    <div>
      <PageHeader title="AI Reports" subtitle="All reports drafted by CONTAHA AI" breadcrumb={["Intelligence", "AI Reports"]} />
      {items && items.length === 0 ? (
        <EmptyState icon={FileBarChart} title="No AI reports yet" description="Generate a report from a case to see it here." actionLabel="Open CONTAHA AI" onAction={() => navigate("/ai")} testId="ai-reports-empty" />
      ) : (
        <div className="space-y-3">
          {(items || []).map((r) => (
            <SurfaceCard key={r.id} className="p-4 cursor-pointer hover:border-[#00A85A]/40" onClick={() => navigate(`/reports/${r.id}`)}>
              <div className="flex items-center gap-4">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#07131A]"><Sparkles className="h-5 w-5 text-[#3FD98A]" /></div>
                <div className="flex-1 min-w-0"><div className="text-sm font-bold text-[#101516] dark:text-white truncate">{r.title}</div><div className="text-xs text-[#8B9698]">{r.type} · {r.patient_name} · {formatDate(r.created_at)}</div></div>
                <StatusBadge status={r.status} />
                <ChevronRight className="h-4 w-4 text-[#8B9698]" />
              </div>
            </SurfaceCard>
          ))}
        </div>
      )}
    </div>
  );
}
